export const BUILD_SUB_TAB_VALUES = ['add-mechanism', 'add-motor', 'add-sensors', 'add-other'] as const;

export type BuildSubTab = (typeof BUILD_SUB_TAB_VALUES)[number];

export const DEFAULT_BUILD_SUB_TAB: BuildSubTab = 'add-mechanism';

export const isBuildSubTab = (value: unknown): value is BuildSubTab => {
  return typeof value === 'string' && BUILD_SUB_TAB_VALUES.includes(value as BuildSubTab);
};
